import { Panel } from '../panel.class';
import { ReferenceMap } from '../../shared.types';

export type DeletePanelVentsParams = {
	panel: Panel;
	refMap: ReferenceMap;
	// ignore panel item groups with keys that exist in this array
	groupExclusions?: Array<string>;
};

export const deletePanelVents = (params: DeletePanelVentsParams): number => {
	// console.log('panels:helpers:-> deletePanelVents', params);
	const { panel, groupExclusions = [] } = params;
	let count = 0;

	if (panel.hasVents) {
		panel.panelItemGroups.children.forEach((piGroup) => {
			// short circuit exclusions
			if (groupExclusions.includes(piGroup.id) || !piGroup.hasVents) return;

			// remove rule-managed vents only (manually placed vents are preserved)
			for (let i = piGroup.items.children.length - 1; i >= 0; i--) {
				const panelItem = piGroup.items.children[i];
				if (panelItem?.item?.category?.isVent && panelItem.ruleManaged) {
					piGroup.items.delete(panelItem.id);
					count++;
				}
			}
		});
	}

	// console.log('panels:helpers:<- deletePanelVents', { count });
	return count;
};
